<template>
  <component :is="layout" v-if="tabCnt > 0" v-bind="$props" :headers="headers" :selected="selected" @select="onSelect">
    <template v-if="label || hasSlotLabel" #label>
      <slot name="label"><span v-html="$to(label)"></span></slot>
    </template>
    <template #default>
      <slot />
    </template>
  </component>
</template>

<script>
export default {
  name: 'Tabset',

  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },

    grayed: {
      type: Boolean,
      required: false,
    },

    slim: {
      type: Boolean,
      required: false,
    },

    unselect: {
      type: Boolean,
      required: false,
    },

    buttons: {
      type: Boolean,
      required: false,
    },

    noSingleHeader: {
      type: Boolean,
      required: false,
    },

    param: {
      type: String,
      required: false,
      default: 'tab',
    },
  },

  data() {
    return {
      headers: [],
      selected: null,
      endOfLife: false,
    };
  },

  computed: {
    layout() {
      if (this.buttons) return require('./ButtonLayout.vue').default;
      return require('./DefaultLayout.vue').default;
    },

    hasSlotLabel() {
      return this.$scopedSlots.label;
    },

    tabCnt() {
      // tabs need not be direct children of the tabset but may be any descendant.
      // recurse through descendants and count VTab tags.
      const sum = (accum, elem) => {
        if (elem.tag?.match(/^vue-component-\d+-VTab$/) || elem.asyncMeta?.tag?.match(/^VTab$/)) accum++;
        // TODO: vue3: this will likely change!
        else if (Array.isArray(elem.children)) accum += elem.children.reduce(sum, 0);
        return accum;
      };
      return this.$scopedSlots.default().reduce(sum, 0);
    },
  },

  beforeDestroy() {
    this.endOfLife = true;
  },

  methods: {
    register(tab) {
      this.headers.push(tab);
      if (!this.selected && this.headers.length >= this.tabCnt) {
        let defaultTab = this.headers.find(h => h.name === this.$route.params[this.param]) || this.headers.find(h => h.active);
        if (!defaultTab && !this.unselect) defaultTab = this.headers[0];
        if (defaultTab) this.onSelect(defaultTab);
      }
    },

    unregister(tab) {
      if (this.endOfLife) return;

      this.headers = this.headers.filter(h => h.name !== tab.name);

      if (this.selected && this.selected.name === tab.name) {
        let defaultTab = this.headers.find(h => h.name === this.$route.params[this.param]) || this.headers.find(h => h.active);
        if (!defaultTab) defaultTab = this.headers[0];
        if (defaultTab) this.onSelect(defaultTab);
      }
    },

    onSelect(tab) {
      this.selected = tab;
      this.$emit('select:tab', tab);
      const params = this.$route.params;
      params[this.param] = tab.name;
      this.$router.replace({ name: this.$route.name, params }).catch(() => {});
    },
  },

  provide() {
    return {
      tabset: this,
    };
  },
};
</script>
